module.exports = __webpack_public_path__ + "img/sk.853919fd.svg";